<!-- Actions for Agreement Edits page -->
<template>
	<div>
		<div class="text-center">
			<div class="inline-flex">
				<vx-tooltip :text="'View'" position="bottom" class="inline-flex mr-2 mt-2 cursor-pointer">
					<feather-icon icon="EyeIcon" :svgClasses="`action-icons cursor-pointer`" @click="clientViewPaymentDetails()"/>
				</vx-tooltip>
			</div>
		</div>	
	</div>	
</template>

<script>
	export default {
		name: 'CellRendererViewAndEditActions',
		data() {
			return {

			}
		},
		methods: {
			clientViewPaymentDetails(){
				var rowData = this.params;
				this.$root.$emit('clientViewPaymentDetails', rowData.data);
			},
		},
	}
</script>
<style lang="scss">
  .disabled{
		pointer-events: none;
        opacity: 0.4;
	}

	.action-icons {
		height: 16px;
		width: 16px;
	}
</style>